/**
 * Service for getting employee-data
 */

import helpers from "./DataserviceHelpers";
import Backend from "../Backend"

/* @ngInject */
class EmployeeData {

  // dirty add-on -> see verwaltung/subitems/mitarbeiter/mitarbeiter.verwaltung.controller.js
  static searchEmployeeLastName = function (lastname) {
    const fields = ["M_Name", "M_Vorname", "M_Pers-Nr", "M_Kostenstelle", "M_Diszi", "M_Standort", "M_Bemerkungen", "M_GebDat"]
    const fieldlist = helpers.generateFieldlist(fields)

    return Backend.getData(`/api/TAB_MITARBEITER/search?M_Name=${lastname}&${fieldlist}`)
  }

  static searchEmployeeFirstName = function (firstname) {
    const fields = ["M_Name", "M_Vorname", "M_Pers-Nr", "M_Kostenstelle", "M_Diszi", "M_Standort", "M_Bemerkungen", "M_GebDat"]
    const fieldlist = helpers.generateFieldlist(fields)

    return Backend.getData(`/api/TAB_MITARBEITER/search?M_Vorname=${firstname}&${fieldlist}`)
  }

  static searchEmployeeByName = function (name) {
    const fields = ["M_Name", "M_Vorname", "M_Pers-Nr", "M_Kostenstelle", "M_Diszi", "M_Standort", "M_Bemerkungen", "M_GebDat"]
    const fieldlist = helpers.generateFieldlist(fields)
    return EmployeeData.fetchSearchData(name, fieldlist)
  }

  static async fetchSearchData(name, fieldlist) {
    let results = [];
    let resultFirstname = await Backend.getData(`/api/TAB_MITARBEITER/search?M_Vorname=${name}&${fieldlist}`);
    if (resultFirstname != null && resultFirstname !== "") {
      resultFirstname.forEach(function (value, key) {
        results.push(value);
      });
    }

    let resultLastname = await Backend.getData(`/api/TAB_MITARBEITER/search?M_Name=${name}&${fieldlist}`);
    if (resultLastname != null && resultLastname !== "") {
      resultLastname.forEach(function (value, key) {
        results.push(value);
      });
    }

    let employees = []
    results.forEach(function (o) {
      let found = false;
      employees.forEach(function (e) {
        if (e['M_Pers-Nr'] === o['M_Pers-Nr']) {
          found = true;
        }
      });
      if (!found) {
        employees.push(o);
      }
    });
    return employees;
  }

  static getEmployeeBaseData = function (gid) {
    const fields = ["M_Name", "M_Vorname", "M_Pers-Nr", "M_Kostenstelle"]
    const fieldlist = helpers.generateFieldlist(fields)

    return Backend.getData(`/api/TAB_MITARBEITER/${gid}?${fieldlist}`)
  }

  static getAllEmployees = function () {
    const fields = ["M_Name", "M_Vorname", "M_Pers-Nr"]
    const fieldlist = helpers.generateFieldlist(fields)

    return Backend.getData(`/api/TAB_MITARBEITER/search?${fieldlist}`)
  }

  static deleteEmployee =function(employeeID) {
    return Backend.deleteData(`/api/TAB_MITARBEITER/${employeeID}`)
  }
}

export default EmployeeData
